import config from "@Config/index";

const tolgee_base_url = `${config.TOLGEE_ENDPOINT}/v2/projects/`;

const getTolgeeConfig = (routeTags: string[] = [], language?: string, hasExistingKeys = false) => {
  const filterTag = hasExistingKeys ? routeTags.join(",") : ["generic", ...routeTags].join(",");

  const projectId = config.isProduction ? "12" : "2";
  const lang = language || (config.IS_CHINA_APP ? "zh" : "en");
  const tolgee_api_key = config.isProduction
    ? config.TOLGEE_APIKEY_PROD
    : config.TOLGEE_APIKEY_STAGING;
  const tolgee_endpoint = `${tolgee_base_url}${projectId}/translations/${lang}?filterTag=${filterTag}&format=true`;

  return { tolgee_endpoint, tolgee_api_key };
};

export default getTolgeeConfig;
